import { keyframes, styled } from '@mui/material';

export const INBOX_CLEAR_ILLUSTRATION_TEST_ID = 'inbox-clear-illustration';

export type InboxClearIllustrationSize = 'pane' | 'page';

const SIZES: Record<InboxClearIllustrationSize, string> = {
  pane: '6rem',
  page: '15.625rem',
};

const badgeBob = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
`;

const sparkTwinkle = keyframes`
  0%, 100% { opacity: .3; transform: scale(.7); }
  50% { opacity: 1; transform: scale(1.15); }
`;

export const BADGE_CLASS = 'InboxClearIllustrationBadge';
export const SPARK_CLASS = 'InboxClearIllustrationSpark';

export const Art = styled('svg', {
  name: 'InboxClearIllustrationArt',
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size: InboxClearIllustrationSize }>(({ size }) => ({
  width: SIZES[size],
  height: 'auto',
  flexShrink: 0,

  [`& .${BADGE_CLASS}`]: {
    animation: `${badgeBob} 3s ease-in-out infinite`,
  },
  [`& .${SPARK_CLASS}`]: {
    animation: `${sparkTwinkle} 2.2s ease-in-out infinite`,
    transformOrigin: 'center',
    transformBox: 'fill-box',
  },
  [`& .${SPARK_CLASS}[data-delay="2"]`]: { animationDelay: '.45s' },
  [`& .${SPARK_CLASS}[data-delay="3"]`]: { animationDelay: '.95s' },
  [`& .${SPARK_CLASS}[data-delay="4"]`]: { animationDelay: '1.4s' },

  '@media (prefers-reduced-motion: reduce)': {
    [`& .${BADGE_CLASS}, & .${SPARK_CLASS}`]: { animation: 'none' },
  },
}));
